export const SDK_VERSION = '7.66.0';
